import React, { useEffect, useState } from "react";
import { Button, Dialog, PlusIcon, SearchInput } from "evergreen-ui";
import { Table, Card, message } from "antd";
import FireFetch from "../../Firebase/FireFetch";
import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { generatePath, useNavigate } from "react-router-dom";
import AddSurvey from "../../Modals/Surveys/AddSurvey";
import moment from "moment";
import { utils, writeFile } from "xlsx";
import { useAuth } from "../../AuthContext/AuthContext";
import TableActionMenu from "../../Common/TableActionMenu";

var db = getDatabase(Firebase);
const Surveys = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateSurvey = canAccessModule("SURVEYS", "create");
	const canDeleteSurvey = canAccessModule("SURVEYS", "delete");
	const columns = [
		{
			title: 'Survey',
			dataIndex: 'title',
			key: 'title',
			sorter: (a, b) => a.title && a.title.localeCompare(b.title)
		},
		{
			title: 'Responses',
			dataIndex: 'responses',
			key: 'responses',
			sorter: (a, b) => a.responses && a.responses - b.responses && b.responses,
		},
		{
			title: 'Expires',
			dataIndex: 'expires',
			key: 'expires',
			sorter: (a, b) => moment(a.expires, "DD/MMM/YYYY HH:MM").diff(moment(b.expires, "DD/MMM/YYYY HH:MM"))
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	]
	const navigate = useNavigate();
	const [surveys, loading] = useListVals(ref(db, "talmidsdb/surveys"));
	const [responses] = useListVals(ref(db, "talmidsdb/surveyResponses"));
	const [users] = useListVals(ref(db, "talmidsdb/users"));
	const [dataArray, setDataArray] = useState([]);
	const [eventsData, setEventsData] = useState([])
	const [checkedData, setCheckedData] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const callback = (data) => {
		setCheckedData(data);
	}
	const proceedToDetails = (id, object) => {
		navigate(generatePath("/surveys/:id", { id }), { state: { survey: object } });
	};

	useEffect(() => {
		setEventsData([]);
		setDataArray([]);
		if (surveys) {
			var tempArray = [];
			surveys.map((item, index) => {
				tempArray.push({
					key: index,
					surveyID: item.surveyID,
					title: item.title,
					assignedUsers: item.assignedUsers,
					questions: Object.values(item.questions || {}),
					responses: (responses || []).filter(x => x.surveyID === item.surveyID)?.length,
					expires: moment(item.expires).format("DD/MMM/YYYY HH:MM"),
					dateCreated: moment(item.dateCreated).format("DD/MMM/YYYY HH:MM"),
					action: (
						<TableActionMenu
							items={[
								{
									key: "view",
									label: "View",
									onClick: () => {
										proceedToDetails(item.surveyID, item);
									},
								},
								canDeleteSurvey && {
									key: "delete",
									label: "Delete",
									danger: true,
									onClick: () => {
										if (!canDeleteSurvey) {
											message.error("You do not have permission to delete surveys.");
											return;
										}

										if (confirm("Are you sure you want to delete this survey? All questions and responses for this survey will be deleted!")) {
											FireFetch.DeleteFromDB("surveys", item.surveyID).then((text) => {
												if (text === "success") {
													FireFetch.addLog("surveys", item.surveyID, "Delete");
													message.success("Survey deleted successfully");
												} else {
													message.error("Unable to delete Survey");
												}
											}).catch(() => {
												message.error("Unable to delete Survey");
											});
										}
									},
								},
							]}
						/>
					)
				})
			});

			setEventsData([...tempArray]);
			setDataArray([...tempArray]);
		}

	}, [responses, surveys, canDeleteSurvey]);

	const handleSearch = searchText => {
		searchText = searchText.toLowerCase();
		const filteredEvents = dataArray.filter(({ title }) => {
			title = title.toLowerCase();
			return title.includes(searchText);
		});

		setEventsData(filteredEvents);
	};

	const downloadExcel = () => {
		var surveyArray = [];
		eventsData.map((survey) => {
			var quest = {};
			quest.survey = survey.title;
			quest.dateCreated = survey.dateCreated;
			quest.expires = survey.expires;

			var userArray = Array.isArray(survey.assignedUsers) ? survey.assignedUsers : [];
			var tempArray = [];
			userArray.forEach((user) => {
				var newuser = users.find(x => x.id === user)?.firstname + " " + users.find(x => x.id === user)?.surname;
				tempArray.push(newuser);
			})
			console.log(tempArray);

			quest.assignedUsers = tempArray.join(" | ")
			var surveyQs = Array.isArray(survey.questions) ? [...survey.questions] : [];
			surveyQs.sort((a, b) => a.questionIndex - b.questionIndex);

			quest.questionNumber = surveyQs.length;
			for (var i = 0; i < surveyQs.length; i++) {
				var option = surveyQs[i];
				if (i === option.questionIndex) {
					quest[`question ${option.questionIndex + 1}`] = option.question;
				}
				else {
					quest[`question ${option.questionIndex}`] = option.question;
				}
			}

			surveyArray.push(quest);
		});

		const worksheet = utils.json_to_sheet(surveyArray);
		const workbook = utils.book_new();
		utils.book_append_sheet(workbook, worksheet, "Sheet1");
		writeFile(workbook, "Surveys.xlsx");
	};

	return (
		<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
			<Dialog
				isShown={showModal}
				title="Create New Survey"
				onCloseComplete={() => { setShowModal(false) }}
				hasFooter={false}
				className="font-Nunito"
			>
				<AddSurvey modal={setShowModal} />
			</Dialog>
			<MDBRow className="w-100">
				<MDBCol md={12}>
					<Card className="w-100">
						<MDBRow>
							<MDBCol md={12}>
								<div className="text-left">
									<div className="d-flex flex-row justify-content-between">
										<div className="d-inline">
											<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
												<Text family='Nunito'>
													Surveys
												</Text>
											</h5>
										</div>
										<div className="d-flex flex-row">
											<SearchInput placeholder="Search surveys..." className="w-100 mx-1" onChange={e => handleSearch(e.target.value)} />
											{canCreateSurvey && (
												<Button appearance="primary" className="mx-2" onClick={() => {
													setShowModal(true);
												}}>
													New Survey <PlusIcon />
												</Button>
											)}
											<Button appearance="primary" className="mx-2" onClick={() => {
												downloadExcel()
											}}>
												Print
											</Button>
										</div>
									</div>
								</div>
							</MDBCol>
						</MDBRow>
					</Card>
					<Card>
						<Table id="dataTable" className="custom-table"
							style={{ overflow: "auto" }}
							loading={loading} columns={columns} dataSource={eventsData} />
					</Card>
				</MDBCol>
			</MDBRow>
		</div>
	);
}

export default Surveys;
